import React from 'react';
import withAppContext from 'tbk-components/src/hooks/withAppContext';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import AnimatedArcs from '../AnimatedArcs';
import cn from 'classnames';

export interface INewsletterProps extends IBaseElementProps {
	image?: IImage;
	title?: string;
	excerpt?: string;
	/**
	 * ID of the Gravity Form to embed
	 */
	gravityFormId?: number;
	children: any;
	footerText?: string;
}

/**
 * Calian Newsletter
 * @icon schedule
 * @block
 */
const Newsletter: React.FC<INewsletterProps> = withAppContext(
	({
		id,
		className,
		classNames = [],
		image,
		title,
		excerpt,
		gravityFormId,
		children,
		footerText,
	}) => {
		return (
			<div
				id={id}
				className={
					className ||
					cn(
						'calian-newsletter px-3 position-relative overflow-hidden',
						...classNames,
					)
				}
			>
				<div className="calian-newsletter__container m-auto d-flex flex-lg-row flex-column align-items-stretech">
					<div className="calian-newsletter__image-col w-100 flex-grow-1 flex-shrink-1">
						<Image
							{...image}
							className="rounded-5 img-fluid w-100 h-100 object-fit-cover"
						/>
					</div>
					<div className="calian-newsletter__content-col w-100 flex-grow-1 flex-shrink-1 rounded-5 d-flex p-5 py-7 justify-content-center align-items-center">
						<AnimatedArcs
							arcsStyle={'Component - Two Lines'}
							arcsPosition="Left"
							arcOneColor={'var(--bs-white)'}
							arcOneStrokeWidth={4}
							arcTwoColor={'var(--bs-primary)'}
							arcTwoStrokeWidth={3}
							classNames={[
								'position-absolute',
								'top-0',
								'start-0',
							]}
						/>
						<div className="newsletter-copy text-center d-flex flex-column align-items-center">
							{title || excerpt ? (
								<div className="newsletter-copy--header">
									{title && (
										<h2 className="newsletter-copy--title mb-3 text-white">
											{title}
										</h2>
									)}
									{excerpt && (
										<p className="newsletter-copy--excerpt mb-4 subheading text-white">
											{excerpt}
										</p>
									)}
								</div>
							) : null}

							{gravityFormId && children && (
								<div className="newsletter-copy--form p-4 w-100 text-white">
									{children}
								</div>
							)}
							{footerText && (
								<p className="newsletter-copy--footer mt-4 mb-0 text-white">
									{footerText}
								</p>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	},
);

export default Newsletter;
